import { Box, Flex } from '@chakra-ui/react';
import {
  GoogleArrowBackIcon,
  GoogleStarIcon,
  GoogleQrCodeIcon,
  GoogleClockIcon,
} from '../../../../../theme/icons/googlePreviewIcons';

interface GooglePhoneHeaderProps {
  contrastColor: string;
  showQrIcon: boolean;
}

export const GooglePhoneHeader = ({ contrastColor, showQrIcon }: GooglePhoneHeaderProps) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    px="12px"
    pt="28px"
  >
    <GoogleArrowBackIcon w="17px" h="17px" color={contrastColor} />
    <Flex gap="18px" alignItems="center">
      <GoogleStarIcon w="17px" h="17px" color={contrastColor} />
      {showQrIcon && (
        <GoogleQrCodeIcon w="15px" h="15px" color={contrastColor} />
      )}
      <GoogleClockIcon w="17px" h="17px" color={contrastColor} />
    </Flex>
  </Box>
);
